import { motion } from "framer-motion";
import { useCopy } from "../i18n";

const EASE = [0.16, 1, 0.3, 1];

export const Experience = () => {
  const copy = useCopy();
  return (
  <section id="esperienza" data-testid="experience-section" className="bg-[#F4F3EF] py-24 lg:py-32">
    <div className="mx-auto max-w-6xl px-6">
      <div className="mb-16 max-w-2xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-5 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.25em] text-[#1E2A38]/70"
        >
          <span className="h-px w-10 bg-[#B89762]" />
          {copy.experience.eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="font-serif-display text-3xl font-light tracking-tight text-[#121316] sm:text-4xl lg:text-5xl"
        >
          {copy.experience.titleA}
          <em className="italic text-[#B89762]">{copy.experience.titleEm}</em>
          {copy.experience.titleB}
        </motion.h2>
      </div>

      <div className="relative ml-3 border-l border-[rgba(18,19,22,0.12)] md:ml-5">
        {copy.experience.jobs.map((job, i) => (
          <motion.div
            key={job.role}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
            data-testid={`experience-item-${i + 1}`}
            className="relative pb-14 pl-8 last:pb-0 md:pl-12"
          >
            <span className="absolute -left-[7px] top-1.5 h-3.5 w-3.5 rounded-full border-2 border-[#B89762] bg-[#FBFBF9]" />
            <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2">
              <h3 className="font-serif-display text-2xl font-medium text-[#121316] sm:text-3xl">{job.company}</h3>
              <span className="rounded-full border border-[rgba(18,19,22,0.12)] bg-[#FBFBF9] px-4 py-1.5 text-xs tracking-wide text-[#1E2A38]/80">
                {job.period}
              </span>
            </div>
            <p className="mt-2 text-sm font-medium uppercase tracking-[0.12em] text-[#B89762]">{job.role}</p>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#525866] sm:text-base">{job.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
        data-testid="experience-summary"
        className="mt-14 max-w-2xl border-t border-[rgba(18,19,22,0.12)] pt-8 text-sm italic leading-relaxed text-[#525866]"
      >
        {copy.experience.summaryA}
        <em>{copy.experience.summaryEm}</em>
        {copy.experience.summaryB}
      </motion.p>
    </div>
  </section>
  );
};

export default Experience;
